module.exports = __webpack_public_path__ + "img/Réalisation rampe inox.01f88fe2.jpg";